import ShadowScrollbar from 'components/ShadowScrollbar'
import {getTokenKey} from 'helpers/localStorage'
import mapObject from 'helpers/mapObject'
import useOnLocationChange from 'modules/navigation/useOnLocationChange'
import React, {useEffect, useState} from 'react'
import useWindowSize from 'react-use/lib/useWindowSize'
import './index.css'
import {LayoutContext} from './LayoutContext'
import {LeftDrawer} from './LeftDrawer'
import {LeftSider} from './LeftSider'
import {NormalLayout} from './NormalLayout'
import {RightDrawer} from './RightDrawer'
import {RightSider} from './RightSider'
import {createLazyComponent} from 'helpers/createLazyComponent'
import {RootHeader} from "../../../views/MainPage/RootHeader.lazy";

const UserMenu = createLazyComponent(() => import('views/Menu/Menu'))
const BottomBar = createLazyComponent(() => import('./BottomBar'))
const SiderMenu = createLazyComponent(() => import('./SiderMenu/SiderMenu'))

const UserLeftMenu = () =>
    getTokenKey() && (
        <div
            style={{
                width: 240,
                flexShrink: 0,
            }}
            className="RightSider stickyTop h-screen">
            <ShadowScrollbar className="w-full h-full">
                <UserMenu/>
            </ShadowScrollbar>
        </div>
    )

export const breakpoints = {
    sm: 641,
    md: 1025,
    // lg: 1281,
    // xl: 1441
}

const breakpointLayoutConfig = {
    xs: {
        header: RootHeader,
        // header: SmallHeader,
        left: LeftDrawer,
        right: RightDrawer,
        bottom: BottomBar,
        showMainPageHeader: true,
        productSize: 2,
    },
    sm: {
        header: RootHeader,
        // header: SmallHeader,
        left: LeftDrawer,
        right: RightDrawer,
        bottom: BottomBar,
        showMainPageHeader: true,
        productSize: 2,
    },
    md: {
        header: RootHeader,
        // header: SmallHeader,
        left: LeftDrawer,
        right: RightDrawer,
        bottom: BottomBar,
        showMainPageHeader: true,
        productSize: 3,
    },
    lg: {
        header: RootHeader,
        left: LeftSider,
        userMenu: UserLeftMenu,
        right: RightSider,
        productSize: 5,
    },
}
const getBreakpoint = (breakpoints, width) => {
    const bp = mapObject(breakpoints, (value, key) => ({
        key,
        value,
    })).find(({value}) => Number(value) > Number(width))

    return bp ? bp.key : 'lg'
}
const useBreakpoints = (breakpoints) => {
    const {width} = useWindowSize()
    const breakpoint = getBreakpoint(breakpoints, width)
    return breakpoint
}

const LayoutProvider = React.memo(({children, hideBottomMenu = false}) => {
    const defaultLeftSider = <SiderMenu/>
    const breakpoint = useBreakpoints(breakpoints)
    const {
        left: LeftLayout,
        right: RightLayout,
        header: Header,
        bottom: Bottom,
        showMainPageHeader,
    } = breakpointLayoutConfig[breakpoint] || breakpointLayoutConfig.xs
    const [leftInner, setLeftInner] = useState(defaultLeftSider)
    const [visibleLeftDrawer, setVisibleLeftDrawer] = useState(false)
    const [visibleRightDrawer, setVisibleRightDrawer] = useState(false)
    const [visibleRightSide, setVisibleRightSide] = useState(true)
    const [openMenu, setOpenMenu] = useState(false)
    const [editableLayout, setEditableLayout] = useState(false)
    const [headerHeight, setHeaderHeight] = useState(50);
    const [rootFontSize, setRootFontSize] = useState(16);
    useOnLocationChange(() => {
        setVisibleLeftDrawer(false)
        setVisibleRightDrawer(false)
        setOpenMenu(false)
    })
    useEffect(() => {
        // Lấy giá trị biến CSS từ :root
        const rootStyle = window.getComputedStyle(document.documentElement);
        const height = rootStyle.getPropertyValue("--header-height").trim();
        setHeaderHeight(parseInt(height));
        const fontSize = window.getComputedStyle(document.documentElement).fontSize;
        setRootFontSize(parseFloat(fontSize));
    }, []);
    const isSm = !!['xs', 'sm'].find((value) => value === breakpoint)
    const isMd = !!['md'].find((value) => value === breakpoint)
    const isLg = !['xs', 'sm', 'md'].find((value) => value === breakpoint)
    return (
        <LayoutContext.Provider
            value={{
                width: 600,
                showMainPageHeader,
                leftSideBarWidth: 'var(--leftSideBar-width)',
                rightSideBarWidth: 'var(--leftSideBar-width)',
                breakpoint,
                breakpoints: breakpoints,
                isSm: isSm,
                isMd: isMd,
                isLg: isLg,
                sampleLimit: isLg ? 3 : 1,
                smallLayout: false,
                LeftLayout,
                Header,
                RightLayout,
                leftInner: leftInner || defaultLeftSider,
                setLeftInner: setLeftInner,
                visibleLeftDrawer,
                setVisibleLeftDrawer,
                visibleRightDrawer,
                stickyOffset: 'var(--sticky-offset)',
                setVisibleRightDrawer,
                visibleRightSide,
                setVisibleRightSide,
                openMenu,
                setOpenMenu,
                editableLayout,
                setEditableLayout,
                collapsedMenuWidth: 60,
                headerHeight,
                rootFontSize
            }}>
            <NormalLayout
                bottom={Boolean(!hideBottomMenu && Bottom) ? <Bottom/> : null}
                header={Header && <Header/>}
                left={<LeftLayout/>}>
                {children}
            </NormalLayout>
        </LayoutContext.Provider>
    )
})

export default LayoutProvider
